import { Box, Flex } from '@televet/kibble-ui/build/chakra';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRetrieveAuthTokenForContactQuery } from 'shared/types/graphql';

const vanityURL = 'https://otto.us2app.churnzero.net';

const SuccessCenter = (): JSX.Element => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const successCenterPublicKey = params.get('next') || '';
  const { data } = useRetrieveAuthTokenForContactQuery();

  const authToken = data?.retrieveAuthTokenForContact?.authToken || '';
  const redirectURL = `${vanityURL}/SuccessCenterCallback?token=${encodeURIComponent(
    authToken,
  )}&next=${successCenterPublicKey}`;

  useEffect(() => {
    if (authToken && successCenterPublicKey) {
      console.log('redirecting to Success Hub...');
      console.log('redirectUrl:', redirectURL);
      window.location.replace(redirectURL);
    }
  }, [authToken, redirectURL, successCenterPublicKey]);

  return (
    <Flex flex="1" flexDirection="column" height="100%" justifyContent="center" alignItems="center">
      You are being redirected to the Success Hub
      <Box color="text.interactive">
        <a href={redirectURL}>Click here if you are not redirected</a>
      </Box>
    </Flex>
  );
};

export default SuccessCenter;
